import React from "react";

import { defaultAddressBreadcrumb } from "./ProfileLegal.helpers";
import Styles from "./ProfileLegal.styles";
import { ProfileLegalProps as Props } from "./ProfileLegal.types";
import ArrowAnchorButton from "components/global/ArrowAnchorButton/ArrowAnchorButton";
import Breadcrumb from "components/global/Breadcrumb/Breadcrumb";
import Footer from "components/global/Footer/Footer";
import Navbar from "components/global/Navbar/Navbar";
import ProfileNavigation from "components/global/ProfileNavigation/ProfileNavigation";
import { CONSTANTS } from "config/constants";
import GoBack from "components/global/GoBack/GoBack";

const { POLITICS_URI, TERMS_URI } = CONSTANTS.DOCUMENTS_URI;

const ProfileLegal: React.FC<Props> = props => {
  return (
    <Styles className="ProfileLegal">
      <header className="ProfileLegal__header">
        <Navbar />
        <Breadcrumb
          items={defaultAddressBreadcrumb}
          className="ProfileLegal__breadcrumb"
        />
      </header>
      <main className="ProfileLegal__main">
        <ProfileNavigation className="ProfileLegal__navigation" />
        <section className="ProfileLegal__content">
          <div className="ProfileLegal__content__header">
            <GoBack />
            <h1 className="ProfileLegal__content__title">Legales</h1>
          </div>
          <div className="ProfileLegal__content__links">
            <ArrowAnchorButton
              buttonText="Términos y condiciones"
              uri={TERMS_URI}
            />
            <ArrowAnchorButton
              buttonText="Políticas de Privacidad"
              uri={POLITICS_URI}
            />
          </div>
        </section>
      </main>
      <footer className="ProfileLegal__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

ProfileLegal.defaultProps = {};

export default ProfileLegal;
